module.exports = "pegasus_template/assets/busy-bee.png";